export const viewCurrencyRatesMenuName = 'Menu::MenuG:ViewCurrencyRate';
